import { DatePicker, Select } from 'antd'
import previous from '../../Assets/Images/previousPolicy.jpg'
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import moment from 'moment';
import axios from 'axios';
import apiUrls from '../../Api/MainApi';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

function PolicyDetails({ data, setData, formData, setFormData }) {
    const [insurerData, setInsurerData] = useState([])
    const [ncb, setNcb] = useState([])
    const [policyType, setPolicyType] = useState([])
    useEffect(() => {
        const fetchInsurerData = async () => {
            const insurerResponse = await axios.get(apiUrls.GetInsurerMasterDropDown);
            const datas = insurerResponse.data.data;
            setInsurerData(datas);
        }
        const fetchNcbData = async () => {
            const ncbResponse = await axios.get(apiUrls.GetNCB);
            const datas = ncbResponse.data.data;
            setNcb(datas);
        }
        const fetchPolicyType = async () => {

            const policyResponse = await axios.post(apiUrls.GetProductDropDown, { name: 'Car' });
            const datas = policyResponse.data.data;
            setPolicyType(datas);
            console.log(datas)
        }
        fetchPolicyType();
        fetchNcbData();
        fetchInsurerData();
    }, [])
    const handleInsurerChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            previousInsurer: selectedOption
        }))
    }
    const handleNcbChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            ncb: selectedOption
        }))
    }
    const handleClaimsChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            previousClaims: selectedOption
        }))
    }
    const handlePolicyChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            policy: selectedOption
        }))
        console.log(selectedOption, "line 61")
    }
    const handlePreviousPolicyChange = (selectedOption) => {
        setFormData(prev => ({
            ...prev,
            previousPolicy: selectedOption
        }))
    }
    const handleDateChange = (date, dateString) => {
        setFormData(prevData => ({
            ...prevData,
            previousPolicyExpiryDate: dateString ? moment(dateString).format('DD-MM-YYYY') : ''
        }));
    };
    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    return (
        <>
            <div className='container mt-4 mb-5'>
                <div className='row'>
                    <div className=' mt-5'>

                        <div className='registration-date d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Expiry Date</span>
                            <DatePicker
                                defaultValue={(dayjs(formData.previousPolicyExpiryDate, 'DD-MM-YYYY'))}
                                className='width-date'
                                onChange={handleDateChange}
                                format='DD-MM-YYYY'
                            />
                        </div>
                        <div className='registration-location d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Previous Policy type</span>
                            <Select
                                name="Policy type"
                                showSearch
                                filterOption={filterOption}
                                value={formData.previousPolicy}
                                onChange={handlePreviousPolicyChange}
                                className="width-specifiying"
                                options={(policyType.length > 0 ? policyType : [{ id: 0, name: "No Make Found" }]).map(policyType => ({ key: `policyType-${policyType.id}`, value: policyType.id, label: policyType.name }))}
                                placeholder="Select Previous Policy Type"
                            />
                        </div>
                        <div className='registration-location d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Made any claims</span>
                            <Select
                                name="Previous claims"
                                showSearch
                                filterOption={filterOption}
                                value={formData.previousClaims}
                                onChange={handleClaimsChange}
                                className="width-specifiying"
                                options={[{ value: "true", label: "Yes" }, { value: "false", label: "No" }]}
                                placeholder="Previous Claims"
                            />
                        </div>
                        {
                            formData.previousClaims === 'false' && (
                                <div className='registration-location d-flex justify-content-between mt-3'>
                                    <span className='mt-1'>Ncb of previos year</span>
                                    <Select
                                        name="Previous insurer"
                                        showSearch
                                        filterOption={filterOption}
                                        value={formData.ncb}
                                        onChange={handleNcbChange}
                                        className="width-specifiying"
                                        options={(ncb.length > 0 ? ncb : [{ id: 0, name: "No Make Found" }]).map(ncb => ({ key: `ncb-${ncb.id}`, value: ncb.id, label: ncb.name }))}
                                        placeholder="Select Ncb Insurer"
                                    />
                                </div>
                            )
                        }
                        <div className='registration-location d-flex justify-content-between mt-3'>
                            <span className='mt-1'>Previous policy insurer</span>
                            <Select
                                name="Previous insurer"
                                showSearch
                                filterOption={filterOption}
                                value={formData.previousInsurer}
                                onChange={handleInsurerChange}
                                className="width-specifiying"
                                options={(insurerData.length > 0 ? insurerData : [{ id: 0, name: "No Make Found" }]).map(make => ({ key: `make-${make.id}`, value: make.id, label: make.name }))}
                                placeholder="Select Previous Insurer"
                            />
                        </div>
                    </div>
                    {/* <div className='col-md-5'>
                        <div className='registration-image-div '>
                            <img src={previous} className='registration-image' alt='policy details' ></img>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default PolicyDetails